const getters = {
  token(state) {
    return state.token;
  },

  user(state) {
    return state.user;
  },

  publicPages(state) {
    return state.publicPages;
  },

  emailSuccess(state) {
    return state.emailSuccess;
  },

  menuAberto(state) {
    return state.menuAberto;
  },

  dadosCompra(state) {
    return state.dadosCompra;
  },

  motivosReembolso(state) {
    return state.motivosReembolso;
  },

  urlAntesLogin(state) {
    return state.urlAntesLogin;
  },

  assinaturaCancelada(state) {
    return state.assinaturaCancelada;
  },

  concordouComVendedor(state) {
    return state.concordouComVendedor;
  },

  refreshingTokenPromise(state) {
    return state.refreshingTokenPromise;
  },

  alterarDadosBancarios(state) {
    return state.alterarDadosBancarios;
  },

  primeiroNomeUsuario(state) {
    return state.user.split(' ')[0];
  },

  rastreio(state) {
    return state.rastreio;
  },
};

export default {
  getters,
};
